import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id F9D30BAE-7AF6-4C02-83AD-18045895B8B0
 * name printer-pos
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos.svg
 * tags
 * - Printer 
 */
export const PrinterPosIcon = createSvgIcon(<><path d="M18 10H6A2 2 0 0 0 4 12V19H20V12A2 2 0 0 0 18 10M18 14H14V12H18M17 9H7V4H17Z" /></>, 'PrinterPosIcon');
export default PrinterPosIcon